import { useEffect, useState } from "react";
import useTopicHandler from "../../hooks/useTopicHandler";
import { useTasksContext } from "../../providers/TasksContextProvider";

export default function useTasksListener() {
  
  // Tasks Context
  const {addTask, deleteTask, updateTask}   = useTasksContext();
  
  const {topicData:taskCreatedData}         = useTopicHandler('team-task-created');
  const {topicData:taskUpdatedData}         = useTopicHandler('team-task-updated');
  const {topicData:taskDeletedData}         = useTopicHandler('team-task-deleted');
  
  const [tasksChanged, setTasksChanged] = useState(Date.now());

  useEffect(()=>{
    if (taskCreatedData) {
      addTask(taskCreatedData);
      setTasksChanged(Date.now());
    }
  }, [taskCreatedData, addTask]);

  useEffect(()=>{
    if (taskDeletedData) {
      deleteTask(taskDeletedData);
      setTasksChanged(Date.now());
    }
  }, [taskDeletedData, deleteTask]);

  useEffect(()=>{
    if (taskUpdatedData) {
      updateTask(taskUpdatedData);
      setTasksChanged(Date.now());
    }
  }, [taskUpdatedData, updateTask]);

  return {
    tasksChanged
  }
}
